/**
 * Validates if a value exists in a collection of valid values.
 *
 * @param {Array | Set | object} validValues - Collection of valid values
 * @param {string|null} value - Value to validate
 * @returns {string|null} - Returns the value if valid, null otherwise
 */
export const validateEnumValue = (validValues, value) => {
  if (!value) {
    return null;
  }

  let values;

  if (validValues instanceof Set) {
    values = validValues;
  } else if (Array.isArray(validValues)) {
    values = new Set(validValues);
  } else {
    values = new Set(Object.values(validValues));
  }

  return values.has(value) ? value : null;
};
